'use client';

import React from 'react';

import Modal from '@/components/V2/Modal';

import '@/styles/globals.v2.css';

import Image from 'next/image';

import { usePdfContext } from '@/components/Providers/PdfProvider';

import { useInterstitialContext } from '../InterstitialModalsContext';
import PrivacyPolicyLink from '../PrivacyPolicyLink';
import { markCartPopupClosed, markHomepagePopupClosed } from '../sessionStorageKeys';
import { SHOWINTERSTITIALMODAL } from '../utils';
import InterstitialModalCloseButton from './InterstitialModalCloseButton';
import InterstitialSignupForm from './InterstitialSignupForm';

const InterStitialModal = () => {
  const { data, closeModal, modals, isCartPage } = useInterstitialContext();
  const { getPdfById } = usePdfContext();

  const privacyPolicyPdf = getPdfById(1);
  // Handle closing the modal without submitting (via X button or clicking outside)
  const handleCloseWithoutSubmit = () => {
    if (isCartPage) {
      markCartPopupClosed();
    } else {
      markHomepagePopupClosed();
    }
    closeModal(SHOWINTERSTITIALMODAL);
  };

  return (
    <Modal
      isOpen={modals.showInterstitialModal}
      onClose={handleCloseWithoutSubmit}
      className="!v2-w-[712px] !v2-p-0"
      closeBtnClassName="v2-top-4 !v2-right-4 v2-w-4 v2-h-4"
      closeButton={InterstitialModalCloseButton}
    >
      <div className="v2-grid v2-grid-cols-1 md:v2-grid-cols-2">
        <div className="v2-w-full v2-flex">
          <Image
            src={data?.informationPopup?.desktopImage ?? ''}
            alt=""
            width={356}
            height={486}
            className="v2-h-full v2-max-w-[356px] v2-w-full v2-hidden md:v2-block"
          />
          <Image
            src={data?.informationPopup?.mobileImage ?? ''}
            alt=""
            width={343}
            height={128}
            className="!v2-w-full v2-h-full md:v2-hidden v2-block v2-rounded-t-[8px]"
          />
        </div>
        <div className="v2-w-full v2-px-4 v2-pt-4 md:v2-pt-[54px] v2-pb-4">
          <p className="v2-font-sweet-sans-pro v2-font-normal v2-text-base v2-leading-[18px] v2-text-[#212427] v2-mb-2">
            {data?.informationPopup?.topText}
          </p>
          <h2 className="v2-text-2xl v2-font-normal v2-font-sweet-sans-pro v2-text-[#212427] v2-mb-2">
            {data?.informationPopup?.heading}
          </h2>
          <p className="v2-font-sweet-sans-pro v2-font-normal v2-text-sm v2-text-[#212427] v2-mb-4">
            {data?.informationPopup?.description}
          </p>
          <InterstitialSignupForm />
          <span className="v2-font-sweet-sans-pro v2-font-normal v2-text-xs v2-text-[#777777]">
            <PrivacyPolicyLink
              text={data?.informationPopup?.disclaimerText ?? ''}
              options={{ match: 'Privacy Policy', href: privacyPolicyPdf?.pdfLink ?? '', target: '_blank' }}
            />
          </span>
        </div>
      </div>
    </Modal>
  );
};

export default InterStitialModal;
